<template>

    <input-child
        v-bind="getInputProps({
            //iconRight: 'fa fa-chevron-down',
            //onIconRightClick: onIconClick
        })"

        v-model="inputValue"

        ref="input"
    >
        <template #input="{ name, id, inputClass, placeholder, required, readonly, disabled, onClick, onFocus, onBlur, value }">
            <textarea
                :name="name || false"
                :id="id"
                :class="['form-control d-flex flex-grow-1 w-100 h-auto border-0 py-0', inputClass]"

                :placeholder="placeholder"

                :required="required"

                :readonly="readonly"
                :disabled="disabled"

                :rows="rows"

                v-on:input="$emit('input', $event.target.value)"

                v-model="inputValue"

                ref="textarea"
            ></textarea>
        </template>

        <template #beforeInput>
            <slot name="beforeInput"></slot>
        </template>
        <template #afterInput>
            <slot name="afterInput"></slot>
        </template>


        <template #hidden>
            <slot
                    name="hidden"
                    v-bind="{}"
            >
            </slot>
        </template>
        <template #next>
            <slot
                    name="next"
                    v-bind="{}"
            >
            </slot>
        </template>
        <template #prev>
            <slot
                    name="prev"
                    v-bind="{}"
            >
            </slot>
        </template>
    </input-child>

</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinInput from './mixinInput';

    import Input from './Input'

    const { props } = Input;

    export default {
        mixins: [ mixinCommon, mixinInput ],

        components: {
            'input-child': Input
        },
        props: {
            ...props,

            rows: {
                type: [String, Number],
                default: 2
            }
        },

        data() {
            return {

            };
        },
        computed: {

        },
        watch: {
            inputValue( inputValue ) {
                this.$emit('input', inputValue);
            }
        },
        mounted() {

        },
        methods: {

            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( Input, overrideProps );
            }
        }
    };
</script>
